import { positiveEvIndex } from '~/apps/product-plus/search-domain/indexes';
import { buildPositiveEvQuery } from '~/apps/product-plus/search-domain/pipelines/positive-ev/build-query';
import {
  getPositiveEvBaseFilters,
  getPositiveEvFacetAttributes,
  getPositiveEvSearchSettings,
  getPositiveEvSorting,
} from '~/apps/product-plus/search-domain/pipelines/positive-ev/query-config';
import { transformPositiveEvResponse } from '~/apps/product-plus/search-domain/pipelines/positive-ev/transform-response';
import { type ValueBetSearchResponseBody } from '~/apps/product-plus/search-domain/pipelines/positive-ev/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/apps/product-plus/search-domain/types';

type CurrentRefinements = Parameters<NonNullable<SearchPipelineDefinition['getSorting']>>[1]['currentRefinements'];

function toFacetFilters(currentRefinements: CurrentRefinements) {
  return currentRefinements.map(refinement =>
    refinement.refinements.map(value => `${refinement.attribute}:${value.value}`),
  );
}

function resolvePositiveEvSorting(
  context: Parameters<typeof getPositiveEvSorting>[0],
  currentRefinements: CurrentRefinements,
) {
  return getPositiveEvSorting(context, toFacetFilters(currentRefinements));
}

export const positiveEvPipelineDefinition: SearchPipelineDefinition<SearchUiState, ValueBetSearchResponseBody> = {
  buildSearchRequest: buildPositiveEvQuery,
  facetAttributes: context => getPositiveEvFacetAttributes(context),
  getBaseFilters: context => getPositiveEvBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getPositiveEvSearchSettings(context).search ?? [],
    sorting: ({ currentRefinements }) => resolvePositiveEvSorting(context, currentRefinements),
  }),
  getSorting: (context, { currentRefinements }) => resolvePositiveEvSorting(context, currentRefinements),
  id: positiveEvIndex,
  searchSettings: context => getPositiveEvSearchSettings(context),
  transformResponse: transformPositiveEvResponse,
};
